"use strict";
exports.__esModule = true;
exports.MANUAL_PAY_PAY_NOW_FAIL_MODAL = exports.MANUAL_PAY_PAY_NOW = void 0;
exports.MANUAL_PAY_PAY_NOW = {
    HEADER: 'Initiate rent payment',
    BODY: 'Ready to {{action}}? Here’s what we’ll do to make it happen.',
    FIRST_PAYMENT_HEADER: 'Flex will collect your {{paymentType}}',
    FIRST_PAYMENT_DUE: 'Due now',
    FIRST_PAYMENT_BUTTON: 'Change',
    FLEX_RENT_HEADER: 'Flex will start processing your full rent payment',
    FLEX_RENT_PAY_TO: 'Pay to',
    FLEX_RENT_AMOUNT: 'Amount',
    CREDIT_REPORT_HEADER: 'Flex will send reports to the credit bureaus',
    CREDIT_REPORT_ROW_ONE: 'Rent paid on time',
    CREDIT_REPORT_ROW_TWO: 'Credit line used responsibly',
    CTA: 'Start payment'
};
exports.MANUAL_PAY_PAY_NOW_FAIL_MODAL = {
    HEADER: "Couldn't complete {{paymentType}}",
    BODY: 'We were unable to complete your {{paymentType}} of {{amount}}. \n \nBefore attempting this {{paymentType}} again, make sure you have enough funds available, and that your card details are correct.',
    CTA: 'Close'
};
